import React from 'react';
import { FaStore } from 'react-icons/fa';
import { MerchantListSkeleton } from './MerchantListSkeleton';

interface Restaurant {
  restaurantId: string;
  name: string;
  address: string;
  phone: string | null;
  cuisineType: string | null;
  image: string | null;
}

interface MerchantPanelProps {
  restaurants: Restaurant[];
  selectedRestaurant: Restaurant | null;
  onRestaurantClick: (restaurant: Restaurant) => void;
  loading: boolean;
}

export const MerchantPanel: React.FC<MerchantPanelProps> = ({
  restaurants,
  selectedRestaurant,
  onRestaurantClick,
  loading
}) => {
  return (
    <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4 shadow-sm flex flex-col h-full overflow-hidden w-[300px] flex-shrink-0">
      <div className="flex items-center justify-between mb-3 flex-shrink-0">
        <div className="flex items-center space-x-2">
          <FaStore className="w-4 h-4 text-[#EF4421]" />
          <h2 className="text-lg font-semibold text-[var(--text-primary)]">Merchants</h2>
        </div>
        <span className="text-xs px-2 py-1 rounded-full bg-[#EF4421] text-white font-medium">
          {loading ? '...' : restaurants.length}
        </span>
      </div>
      <div className="space-y-2 overflow-y-auto flex-1 min-h-0 px-1 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
        {loading ? (
          <MerchantListSkeleton />
        ) : (
          restaurants.map((restaurant) => (
            <div 
              key={restaurant.restaurantId}
              role="button"
              tabIndex={0}
              onClick={() => onRestaurantClick(restaurant)}
              onKeyDown={(e) => e.key === 'Enter' && onRestaurantClick(restaurant)}
              className={`flex items-center space-x-3 p-3 rounded-lg transition-all duration-200 cursor-pointer ${
                selectedRestaurant?.restaurantId === restaurant.restaurantId 
                  ? 'bg-[#EF4421]/10' 
                  : 'bg-[var(--bg-tertiary)] hover:bg-[var(--bg-hover)]'
              }`}
            >
              <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: 'linear-gradient(135deg, #FF6B4A, #EF4421)' }}>
                <FaStore className="w-4 h-4 text-white" />
              </div>
              <div className="min-w-0">
                <p className="text-sm font-medium text-[var(--text-primary)] truncate">{restaurant.name}</p>
                <p className="text-xs text-[var(--text-muted)] truncate">{restaurant.address}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
